import ReputationCalculationMode from "./ReputationCalculationMode";
import { ReputationCalculationModeEnum } from "../types";

export default class RandomReputationCalculationMode extends ReputationCalculationMode {
  type = ReputationCalculationModeEnum.Random

  min!: number
  max!: number
}
